import React, { useEffect, useState } from "react";
import Header from "../common/header/Header";
import UserTotalCount from "./user-total-count";
import UserSubHeader from "./user-sub-header";
import { ServerSideCustomPagination } from "./server-side-custom-pagination";
import SortBy from "../common/sort-by/sort-by";
import ExportDropdown from "../common/export-dropdown/export";
import Tabs from "./tabs";
import SlideHeader from "../common/slide-header/slide-header";
import AddNewRole from "./add-new-role";
import AddNewUser from "./add-new-user";
import PermissionButton from "./permission-button";
import PermissionsPanel from "./permission-panel";
import UserList from "./user-list";
import {
  addNewRole,
  addUser,
  deleteUser,
  getAllRolesMapping,
  getPermissionsByRoleId,
  getUsersByRole,
  submitPermission,
} from "../../js/api/user-access";
import SlideFooter from "../common/slide-footer/slide-footer";
import { Toast } from "../common/toast/toast";
import { useDispatch, useSelector } from "react-redux";
import { getAccessUser } from "../../reducer/slices/access-users/access-user-slice";
import { useLocation, useNavigate, useSearchParams } from "react-router";
import DeleteUserPopup from "./delete-user-popup";
import AllowedAccess from "../../guards/AllowedAccess";
import PermissionList from "../../guards/PermissionList";
import { DeleteIcon } from "../../assets/icons/user-access-icons/delete-icon";
import { DeleteHoverIcon } from "../../assets/icons/user-access-icons/delete-hover-icon";
import SearchInput from "./search-input";
const UserAccess = () => {
  const [isSlideOpen, setIsSlideOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [roleCardData, setRoleCardData] = useState();
  const [roleerror, setRoleError] = useState("");
  const [selectedRoleId, setSelectedRoleId] = useState();
  const [permissionData, setPermissionData] = useState();
  const [openaddUser, setOpenAddUser] = useState(false);
  const [openaddRole, setOpenAddRole] = useState(false);
  const [usersRoleBase, setUserRoleBase] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const searchTermFromUrl = searchParams.get("searchTerm") || "";
  const [search, setSearch] = useState(searchTermFromUrl);
  const [showClose, setShowClose] = useState(false);
  const [paginationValue, setPaginationValue] = useState({
    count: 0,
    pages: 0,
    hasPrevious: false,
    hasNext: false,
  });
  const [roleLoading, setRoleLoading] = useState(true);
  const page = searchParams.get("page") || 0;
  const perPage = searchParams.get("per_page") || 10;
  const sorting = searchParams.get("sorting") || "firstName";

  const [currentPage, setCurrentPage] = useState(page);
  const [rowsPerPage, setRowsPerPage] = useState(perPage);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    roleName: "",
  });
  const [roleData, setRoleData] = useState("");
  const [addUserErrors, setAddUserErrors] = useState({});
  const [toasts, setToasts] = useState([]);
  const [permissionDrawerLoading, setPermissionDrawerLoading] = useState();
  const [permissionPayload, setPermissionPayload] = useState();
  const [disablePagination, setDisablePagination] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState();
  const [deleteHoveredUserId, setDeleteHoveredUserId] = useState(null);
  const accessUserData = useSelector((state) => state.accessUsers);
  const location = useLocation();
  const oldparams = new URLSearchParams(location.search);
  const querySort = oldparams.get("sorting");
  let navigate = useNavigate();

  const params = new URLSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("permissionPayload", permissionPayload);
    console.log("isDeletePopup", isDeletePopup);
  }, [permissionPayload, isDeletePopup]);

  // toaster
  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000); // Auto-dismiss after 3 seconds
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  const getRole = async () => {
    const data = await getAllRolesMapping();
    setRoleCardData(data.data);
  };

  const handleAddUserSubmit = () => {
    const errors = {};

    if (!userData.firstName?.trim())
      errors.firstName = "First name is required";
    if (!userData.lastName?.trim()) errors.lastName = "Last name is required";
    if (!userData.email?.trim()) errors.email = "Email is required";
    if (!userData.roleName?.trim()) errors.roleName = "Role is required";

    setAddUserErrors(errors);

    if (Object.keys(errors).length > 0) return;

    setAddUserErrors(errors);
    const payload = {
      ...userData,
      clinicalInfoIDs: [],
    };

    addUser(payload)
      .then(() => {
        setUserData({
          firstName: "",
          lastName: "",
          email: "",
          roleName: "",
        });
        setIsSlideOpen(false);
        setOpenAddUser(false);
        addToast("User has been added successfully.", "success");
      })
      .catch((error) => {
        console.error("Error adding user:", error);
        const errorMessage =
          error?.response?.data?.message ||
          "Failed to add user. Please try again.";
        addToast(errorMessage, "error");
      });
  };

  const handleAddRoleSubmit = () => {
    addNewRole(roleData).then(() => {
      getRole();
      setIsSlideOpen(false);
      setRoleData(false);
      setOpenAddRole(false);
      addToast("Role has been added successfully.", "success");
    });
  };

  const onAddRoleClick = () => {
    setIsSlideOpen(!isSlideOpen);
  };
  const onAddUserClick = () => {
    setIsSlideOpen(!isSlideOpen);
  };
  const openAddUserDrawer = () => {
    setIsSlideOpen(false);
    setSelectedRoleId(false);
    setPermissionData(false);
    setOpenAddUser(true);
    setOpenAddRole(false);
    setTimeout(() => {
      setIsSlideOpen(true);
    }, 300);
  };
  const openAddRoleDrawer = () => {
    setIsSlideOpen(false);
    setSelectedRoleId(false);
    setPermissionData(false);
    setOpenAddUser(false);
    setOpenAddRole(true);

    setTimeout(() => {
      setIsSlideOpen(true);
    }, 300);
  };
  useEffect(() => {
    const fetchRoles = async () => {
      await getRole();
    };
    fetchRoles();
  }, []);

  const openPermissionDrawer = async (selectedRoleId) => {
    console.log("selectedRoleId", selectedRoleId);
    setIsSlideOpen(false);
    setSelectedRoleId(false);
    setPermissionData(false);
    setOpenAddUser(false);
    setOpenAddRole(false);
    setIsSlideOpen(true);
    setPermissionDrawerLoading(true);
    try {
      const permissionData = await getPermissionsByRoleId(selectedRoleId);
      console.log("permissionData", permissionData.data.data);
      setPermissionData(permissionData);
      setSelectedRoleId(selectedRoleId);
      setPermissionDrawerLoading(false);
    } catch (error) {
      console.error("Error loading permissions:", error);
    }
  };
  function userByRole(searchText = "") {
    setDisablePagination(true);
    getUsersByRole({
      roleId: activeTab === "all" ? "" : activeTab,
      page: Number(currentPage) + 1,
      pageSize: Number(perPage),
      sorts: sorting,
      searchTerm: searchText, // ✅ same param name for consistency
    })
      .then((response) => {
        const data = response.data;
        setUserRoleBase(data.items);
        setPaginationValue({
          count: data.count,
          from: data.from,
          hasNext: data.hasNext,
          hasPrevious: data.hasPrevious,
          index: data.index,
          pages: data.pages,
          size: data.size,
        });
        setDisablePagination(false);
      })
      .catch(() => setDisablePagination(false));
  }

  const handleSearch = () => {
    if (!search.trim()) return;

    console.log("🔍 handleSearch:", search);

    // ✅ Update query params in URL
    setSearchParams((prevParams) => {
      const updatedParams = new URLSearchParams(prevParams);
      updatedParams.set("searchTerm", search.trim()); // reset to first page
      return updatedParams;
    });

    setDisablePagination(true);

    getUsersByRole({
      roleId: activeTab === "all" ? "" : activeTab,
      page: 1,
      pageSize: Number(perPage),
      sorts: sorting,
      searchTerm: search.trim(), // ✅ Correct param name
    })
      .then((response) => {
        const data = response.data;
        setUserRoleBase(data.items);
        setPaginationValue({
          count: data.count,
          from: data.from,
          hasNext: data.hasNext,
          hasPrevious: data.hasPrevious,
          index: data.index,
          pages: data.pages,
          size: data.size,
        });
        setShowClose(true);
      })
      .catch((error) => console.error("❌ Error in search:", error))
      .finally(() => setDisablePagination(false));
  };

  const updateQueryParams = (newPage, newPerPage, search) => {
    console.log("params", params);
    newPage && params.set("page", newPage.toString());
    newPerPage && params.set("per_page", newPerPage.toString());
    search && params.set("searchTerm", search);
    params.set("sorting", querySort);
    navigate(`?${params.toString()}`);
  };
  const [sortOrder, setSortOrder] = useState(sorting ? sorting : "-firstName");
  const updateQueryParamsSorting = (sortingVal) => {
    let Sorts;
    params.set("page", page);
    params.set("per_page", perPage);
    params.set("sorting", sortingVal);
    search && params.set("searchTerm", search);
    if (sortingVal === "desc") {
      Sorts = "-firstName";
    }
    if (sortingVal === "asc") {
      Sorts = "firstName";
    }
    navigate(`?${params.toString()}`);
  };

  const handleSort = (sortType, data, sortingQueryChange) => {
    console.log("sortOrder sortType", sortType);
    setSortOrder(sortType);
    if (sortingQueryChange) {
      updateQueryParamsSorting(sortType);
    }
  };

  const handlePerPageChange = (size) => {
    setCurrentPage(0);
    setRowsPerPage(size);
    updateQueryParams(0, size, search);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    updateQueryParams(page, perPage, search);
  };

  useEffect(() => {
    setRoleLoading(true);
    dispatch(getAccessUser()).then(() => {
      setRoleLoading(false);
    });
    userByRole();
  }, []);

  useEffect(() => {
    console.log("page", page);
    console.log("perPage", perPage);
    if (page === 0) {
      setCurrentPage(0);
      setRowsPerPage(10);
    } else {
      setCurrentPage(page);
      setRowsPerPage(10);
    }
    if (perPage === 10) {
      setRowsPerPage(10);
    } else {
      setCurrentPage(page);
      setRowsPerPage(perPage);
    }
  }, [page, perPage]);

  useEffect(() => {
    console.log("useEffect page", page);
    console.log("useEffect perPage", perPage);
    console.log("useEffect currentPage", currentPage);
    console.log("useEffect rowsPerPage", rowsPerPage);
  }, [page, perPage, currentPage, rowsPerPage]);

  useEffect(() => {
    updateQueryParams(0, 10, search);
    userByRole('');

  }, [activeTab]);

  useEffect(() => {
    userByRole(search);
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    userByRole(search);
  }, [sorting]);

  const updatePermission = () => {
    submitPermission(permissionData.data.data, selectedRoleId)
      .then((res) => {
        // setIsSlideOpen(false);
        //setSelectedRoleId(false);
        addToast("Permissions updated", "success");
      })
      .catch((err) => {
        addToast("Failed to update permissions", "error");
      });
  };

  const closePopup = () => {
    setIsDeletePopup(false);
  };

  const userList = [
    {
      name: "Account Name",
      selector: (row) => row.accountName,
    },
    {
      name: "Email Address",
      selector: (row) => row.email,
    },
    {
      name: "Role",
      selector: (row) => row.roleName,
    },
    {
      name: "Delete",
      selector: (row) => (
        <div className="flex justify-center w-[100%]">
          <button
            disabled={row.isActive === false}
            className={`${row.isActive ? "" : "cursor-not-allowed opacity-50"}`}
            onClick={() => {
              setIsDeletePopup(row);
            }}
            onMouseEnter={() => setDeleteHoveredUserId(row.userId)}
            onMouseLeave={() => setDeleteHoveredUserId(null)}
          >
            {deleteHoveredUserId === row.userId && row.isActive ? (
              <DeleteHoverIcon />
            ) : (
              <DeleteIcon />
            )}
          </button>
        </div>
      ),
      center: true,
      width: "100px",
    },
  ];

  const searchaction = (e) => {
    const value = e.target.value;
    setSearch(value);

    if (!value.trim()) {
      setShowClose(false);
      onCloseClick()
    }
  };

  const onSearchClick = () => {
    if (search && search.trim().length > 0) {
      setShowClose(true);
      handleSearch(search);
    }
  };

  const onCloseClick = () => {
    setSearch("");
    setShowClose(false);
    setSearchParams((prevParams) => {
      const updatedParams = new URLSearchParams(prevParams);
      updatedParams.delete("searchTerm");
      return updatedParams;
    });
    setSearch("");
    userByRole("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearchClick();
    }
  };

  useEffect(() => {
    const searchTermFromUrl = searchParams.get("searchTerm");
    if (searchTermFromUrl) {
      setSearch(searchTermFromUrl);
      setShowClose(true);
      getUsersByRole({
        roleId: activeTab === "all" ? "" : activeTab,
        page: 1,
        pageSize: Number(perPage),
        sorts: sorting,
        searchTerm: searchTermFromUrl,
      }).then((response) => {
        const data = response.data;
        setUserRoleBase(data.items);
        setPaginationValue({
          count: data.count,
          from: data.from,
          hasNext: data.hasNext,
          hasPrevious: data.hasPrevious,
          index: data.index,
          pages: data.pages,
          size: data.size,
        });
      });
    }
  }, []); // run once


  return (
    <>
      {isDeletePopup ? (
        <DeleteUserPopup
          closePopup={closePopup}
          name={isDeletePopup.accountName}
          userId={isDeletePopup.userId}
          deleteUser={deleteUser}
          addToast={addToast}
        />
      ) : (
        ""
      )}
      <Header headertitle="User Access" />
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}

      <UserSubHeader
        addButtonTitle={"Add New Role"}
        classes={"z-[1]"}
        onAddClick={openAddRoleDrawer}
      />

      {/* add scroll here and remove from full screen */}
      <div className="">
        {/* Left Section */}
        <div
          className={`transition-all duration-300 ease-in-out ${isSlideOpen ? "w-[calc(100%-550px)]" : "w-full"
            }`}
        >

          <UserTotalCount
            isSlideOpen={isSlideOpen}
            roleCardData={roleCardData}
            openPermissionDrawer={openPermissionDrawer}
            roleLoading={roleLoading}
            setRoleLoading={setRoleLoading}
          />
          <AllowedAccess permissions={[PermissionList.admin_userAccess.view_user_access]}>
            <UserSubHeader
              addButtonTitle="Add New User"
              stickyVal={"top-[150px]"}
              Pagination={
                <ServerSideCustomPagination
                  customstyles={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0px",
                    gap: "10px",
                    fontFamily: "Arial, sans-serif",
                  }}
                  rowsPerPage={perPage}
                  rowCount={paginationValue.count}
                  onChangePage={handlePageChange}
                  currentPage={currentPage}
                  handlePerPageChange={handlePerPageChange}
                  totalPages={paginationValue.pages}
                  hasPrevious={paginationValue.hasPrevious}
                  hasNext={paginationValue.hasNext}
                  disablePagination={disablePagination}
                />
              }
              onAddClick={openAddUserDrawer}
              Sort={<SortBy handleSort={handleSort} />}
              Export={
                <ExportDropdown
                  currentPageData={usersRoleBase}
                  ListColumns={userList}
                />
              }
            />
            <div className="flex justify-between items-center pr-6 mb-4">
              <Tabs
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                roles={roleCardData}
              />
              {/* <div className="relative">
              <input
                type="search"
                className="block px-4 py-2 text-sm title_color rounded-[5px] border table_border w-[425px] h-9"
                placeholder="Search by Name or Contact..."
                value={search}
                onChange={(e) => {
                  searchaction(e);
                }}
                onKeyDown={handleKeyDown}
                required
              />

              {showClose ? (
                <button
                  className="w-6 h-6 blue_bg rounded-[50%] inline-flex items-center justify-center absolute top-1/2 -translate-y-1/2 right-2"
                  onClick={() => onCloseClick()}
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1 1L12 12" stroke="white" strokeWidth="2" />
                    <path d="M12 1L1 12" stroke="white" strokeWidth="2" />
                  </svg>
                </button>
              ) : (
                <button
                  className="w-6 h-6 blue_bg rounded-[50%] inline-flex items-center justify-center absolute top-1/2 -translate-y-1/2 right-2"
                  onClick={() => onSearchClick()}
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.4202 9.71315C10.225 9.51789 9.9084 9.51788 9.71313 9.71314C9.51787 9.9084 9.51787 10.225 9.71313 10.4203L10.4202 9.71315ZM11.8464 12.5536C12.0417 12.7488 12.3582 12.7488 12.5535 12.5536C12.7488 12.3583 12.7488 12.0417 12.5535 11.8464L11.8464 12.5536ZM4.9277 3.12667C5.20044 3.08347 5.38652 2.82735 5.34333 2.55461C5.30013 2.28187 5.04401 2.09578 4.77126 2.13898L4.9277 3.12667ZM2.13897 4.77128C2.09577 5.04402 2.28185 5.30015 2.55459 5.34334C2.82733 5.38654 3.08346 5.20046 3.12665 4.92772L2.13897 4.77128ZM9.71313 10.4203L11.8464 12.5536L12.5535 11.8464L10.4202 9.71315L9.71313 10.4203ZM5.79999 10.1C3.42517 10.1 1.5 8.17481 1.5 5.79999H0.5C0.5 8.7271 2.87289 11.1 5.79999 11.1V10.1ZM10.1 5.79999C10.1 8.17481 8.17481 10.1 5.79999 10.1V11.1C8.72709 11.1 11.1 8.7271 11.1 5.79999H10.1ZM5.79999 1.5C8.17481 1.5 10.1 3.42517 10.1 5.79999H11.1C11.1 2.87289 8.72709 0.5 5.79999 0.5V1.5ZM5.79999 0.5C2.87289 0.5 0.5 2.87289 0.5 5.79999H1.5C1.5 3.42517 3.42517 1.5 5.79999 1.5V0.5ZM4.77126 2.13898C3.41627 2.35359 2.35357 3.41629 2.13897 4.77128L3.12665 4.92772C3.27349 4.00062 4.0006 3.27351 4.9277 3.12667L4.77126 2.13898Z"
                      fill="white"
                    />
                  </svg>
                </button>
              )}
            </div> */}
              <SearchInput
                search={search}
                onSearchChange={searchaction}
                onSearchClick={onSearchClick}
                onCloseClick={onCloseClick}
                handleKeyDown={handleKeyDown}
                showClose={showClose}
              />
            </div>

            <UserList
              usersRoleBase={usersRoleBase}
              userList={userList}
              setIsDeletePopup={setIsDeletePopup}
            />
          </AllowedAccess>
        </div>

        {/* Right Slide Panel */}
        <div
          className={`fixed right-0 top-[76px] w-[570px] h-[calc(100vh-75px)] bg-white border-l border-[#C8D6E6] shadow-lg z-50 transition-transform duration-300 ease-in-out ${isSlideOpen ? "translate-x-0" : "translate-x-full"
            }`}
        >
          <SlideHeader
            // title={openaddUser ? "Add New User" : "Add New Role"}
            title={
              openaddUser
                ? "Add New User"
                : openaddRole
                  ? "Add New Role"
                  : selectedRoleId
                    ? `Update Permssion`
                    : () => { }
            }
            onClickClose={() => {
              setIsSlideOpen(false);
              setSelectedRoleId(false);
            }}
          />
          {openaddRole ? (
            <AddNewRole
              setRoleData={setRoleData}
              roleData={roleData}
              roleAlreadydData={roleCardData}
              error={roleerror}
              setError={setRoleError}
            />
          ) : (
            ""
          )}
          {openaddUser ? (
            <AddNewUser
              userData={userData}
              setUserData={setUserData}
              roleCardData={roleCardData}
              addUserErrors={addUserErrors}
              setAddUserErrors={setAddUserErrors}
            />
          ) : (
            ""
          )}
          {permissionDrawerLoading ? (
            <div class="flex items-center justify-center h-[calc(100vh_-_238px)]">
              <div className="spinner"></div>{" "}
            </div>
          ) : selectedRoleId ? (
            <PermissionsPanel
              data={permissionData.data.data}
              roleId={selectedRoleId}
              setPermissionPayload={setPermissionPayload}
              addToast={addToast}
            />
          ) : (
            ""
          )}

          <AllowedAccess
            applyOnCondtion={selectedRoleId}
            permissions={[PermissionList.admin_userAccess.edit_permissions]}
          >
            <SlideFooter
              handleSubmit={
                openaddUser
                  ? handleAddUserSubmit
                  : openaddRole
                    ? handleAddRoleSubmit
                    : selectedRoleId
                      ? updatePermission
                      : () => { }
              }
              disableSubmit={
                (openaddRole && roleData == "") || (openaddRole && roleerror)
                  ? true
                  : false
              }
              closePopup={() => {
                setIsSlideOpen(false);
                setSelectedRoleId(false);
                setPermissionData(false);
                setOpenAddUser(false);
              }}
            />
          </AllowedAccess>
        </div>
      </div>
    </>
  );
};

export default UserAccess;
